module.exports = __webpack_public_path__ + "img/smog.ee13db9e.svg";